import {
  finalCTASection,
  mapSection,
  photoCarouselSection,
  ppcCtaSection,
  ppcFaqsSection,
  ppcHeroSection,
  ppcOfferingsSection,
  ppcOurProcessSection,
  ppcServiceAreasSection,
  ppcTestimonialsSection,
  ppcWhySection,
} from "@/lib/constants/sections/individualSections";

const PPC_SECTIONS = [
  ppcHeroSection,
  photoCarouselSection,
  ppcWhySection,
  finalCTASection,
  ppcOurProcessSection,
  ppcTestimonialsSection,
  ppcOfferingsSection,
  ppcServiceAreasSection,
  mapSection,
  ppcFaqsSection,
  ppcCtaSection,
];

const NON_PPC_SECTIONS = [mapSection, finalCTASection, photoCarouselSection];

export const PPC_SECTIONS_ONLY = PPC_SECTIONS.filter((section) => !NON_PPC_SECTIONS.includes(section));

export default PPC_SECTIONS.map((s, idx) => ({
  ...s,
  order: idx + 1,
}));
